import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="FPL Live" link="https://github.com/kevinheych/FPLdroid" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  An Android appplication which allows users to check on there Fantasy Premier League stats and standings. Coded in Java with Retrofit client.
    </ProjectCard>
    <ProjectCard title="WeatherApp" link="https://github.com/kevinheych/WeatherApp" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  A GUI desktop app written in Python using the Tkinter module
    </ProjectCard>
    <ProjectCard title="iFantasy Live" link="https://github.com/kevinheych/iFantasy" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
  A native iOS custom app to check FPL live stats, written in Swift.
    </ProjectCard>
 
 

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      